import type { ImageInput, ImageRotation, ParametricFilter, Point, SaveImageOptions } from '../types';
import { ImageRef, handleImageInput, withSBErrorHandling } from '../types';

import { ScanbotSDKPlugin } from './Definitions';

/**
 * @internal
 * @hidden
 */
export const ScanbotImageProcessorImpl = {
  async applyFiltersOnImageFile(params: {
    imageFileUri: string;
    filters: ParametricFilter[];
    overwrite?: boolean;
    saveOptions?: SaveImageOptions;
  }): Promise<string> {
    return withSBErrorHandling(async () => {
      return (await ScanbotSDKPlugin.applyFiltersOnImageFile(params)).result;
    });
  },

  async applyFilters(params: { image: ImageInput; filters: ParametricFilter[] }): Promise<ImageRef> {
    return withSBErrorHandling(async () =>
      ImageRef.from(
        await ScanbotSDKPlugin.applyFiltersOnImage({ filters: params.filters, image: handleImageInput(params.image) }),
      ),
    );
  },

  async rotateImageFile(params: {
    imageFileUri: string;
    rotation: ImageRotation;
    overwrite?: boolean;
    saveOptions?: SaveImageOptions;
  }): Promise<string> {
    return withSBErrorHandling(async () => {
      return (await ScanbotSDKPlugin.rotateImageFile(params)).result;
    });
  },

  async rotate(params: { image: ImageInput; rotation: ImageRotation }): Promise<ImageRef> {
    return withSBErrorHandling(async () =>
      ImageRef.from(
        await ScanbotSDKPlugin.rotateImage({ rotation: params.rotation, image: handleImageInput(params.image) }),
      ),
    );
  },

  async readImageData(imageFileUri: string): Promise<string> {
    return withSBErrorHandling(async () => {
      return (await ScanbotSDKPlugin.readImageData({ imageFileUri: imageFileUri })).result;
    });
  },

  async resizeImageFile(params: {
    imageFileUri: string;
    maxSize: number;
    overwrite?: boolean;
    saveOptions?: SaveImageOptions;
  }): Promise<string> {
    return withSBErrorHandling(async () => {
      return (await ScanbotSDKPlugin.resizeImageFile(params)).result;
    });
  },

  async resize(params: { image: ImageInput; maxSize: number }): Promise<ImageRef> {
    return withSBErrorHandling(async () =>
      ImageRef.from(
        await ScanbotSDKPlugin.resizeImage({ maxSize: params.maxSize, image: handleImageInput(params.image) }),
      ),
    );
  },

  async cropImageFile(params: {
    imageFileUri: string;
    polygon: Point[];
    overwrite?: boolean;
    saveOptions?: SaveImageOptions;
  }): Promise<string> {
    return withSBErrorHandling(async () => {
      return (await ScanbotSDKPlugin.cropImageFile(params)).result;
    });
  },

  async crop(params: { image: ImageInput; polygon: Point[] }): Promise<ImageRef> {
    return withSBErrorHandling(async () =>
      ImageRef.from(
        await ScanbotSDKPlugin.cropImage({ polygon: params.polygon, image: handleImageInput(params.image) }),
      ),
    );
  },
};
